import { getByID } from '@adornis/baseql/operations/mongo.js';
import { loadMongoData } from '@adornis/baseql/server/data-loader.js';
import { selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { getMentorUserClass } from '@adornis/bh-matching-matches/user-class.js';
import { defineMailTemplate } from '@adornis/mails/db/mail-template-definition.js';
import { BuddyMailAttachment } from '../entities/attachment.js';
import {
  BuddyMailTemplate,
  convertUserToMailVarObject,
  getMentorFields,
  MailTemplateType,
} from '../entities/mail-templates.js';

export function registerRegistrationMentor() {
  return defineMailTemplate(MailTemplateType.REGISTRATION_MENTOR, {
    getMailData: async (mentorID: string) => {
      const user = await getByID(getMentorUserClass(), mentorID)(selectionSet(() => getMentorUserClass(), 2));
      if (!user) throw new Error('Mentor user(' + getMentorUserClass()._class + ') not found: ' + mentorID);
      const data = convertUserToMailVarObject(user as any);

      // attachments
      const mailTemplate = await loadMongoData(BuddyMailTemplate, {
        emailType: MailTemplateType.REGISTRATION_MENTOR,
      }).then(res => res?.[0]);
      if (!mailTemplate) throw new Error('No mail template found for type ' + MailTemplateType.REGISTRATION_MENTOR);

      const attachments = {};
      const attachmentData = await loadMongoData(BuddyMailAttachment, {
        _id: { $in: mailTemplate.activatedAttachments },
      });
      for (const attachment of attachmentData) {
        attachments[attachment._id] = `${BuddyMailAttachment.getServeLink(attachment._id)}/${
          attachment.meta?.fileName ?? 'file'
        }.${attachment.meta?.extension ?? 'txt'}`;
      }

      return { data, attachments, scope: 'default' };
    },
    defaultTemplate: {
      subject: `Herzlich willkommen bei GROW@Goethe Mentoring (SoSe 2024): Ihre Anmeldung/Registrierung`,
      content: `<p>Hallo {{anrede}}&nbsp;{{firstName}} {{lastName}},<br></p><p>wir bedanken uns herzlich für Ihre Anmeldung zum Mentoring-Programm GROW@Goethe. Hiermit bestätigen wir erfolgreich Ihre Registrierung und freuen uns auf den Start der nächsten Mentoring-Runde im Sommersemester 2024. Die Anmeldefrist für Mentor*innen endet am 24. März. Im Anschluss werden wir Ihr Profil anonymisiert freischalten, damit sich unsere Studierenden bis Mitte April bewerben können.</p>
<p>Sobald wir einen passenden Mentee für Sie gefunden haben, werden wir Sie zu einem Match zusammenführen. Die Benachrichtigung über das jeweilige Match für Sie und Ihren Mentee erfolgt am 28. April 2024 per E-Mail. Wir bitten um Ihr Verständnis und Geduld in dieser Angelegenheit. </p>
<p> Bei Fragen melden Sie sich gerne unter:&nbsp;<a href="mailto:mentoring@uni-frankfurt.de">mentoring@uni-frankfurt.de</a>. </p>
<p> Wir freuen uns darauf, Sie bald persönlich kennenzulernen.
</p>
<p> Mit freundlichen Grüßen, </p>
<p> Ihr Mentoring-Team</p>`,
      footer: '',
    },
    variables: getMentorFields(),
    attachments: [],
    displayName: 'Registrierung: Mentor',
    editorHint: () => 'Bestätigungsmail nach erfolgreichem Registrieren zu Workshops.',
  });
}
